import { FormikCheckboxField } from '@superdispatch/forms';
import { useFormikContext } from 'formik';
import { isValidLATRSearchCriteria } from 'shared/modules/loadboard/PostingSearchCriteriaDTO';
import { PostingSavedSearchPayloadDTO } from '../../data/dto/PostingSavedSearchDTO';
import { trackLoadboardEvent } from '../LoadboardAnalytics';

export function LATRCheckboxField() {
  const { values } = useFormikContext<PostingSavedSearchPayloadDTO>();
  const isLATRValid = isValidLATRSearchCriteria(values.search_criteria);

  return (
    <FormikCheckboxField
      helperText={
        !isLATRValid
          ? 'To enable, enter one origin city OR zip and one destination city OR zip.'
          : ''
      }
      name="search_criteria.search_along_route"
      label="Search Along Route"
      disabled={!isLATRValid}
      onChange={(_, checked) => {
        trackLoadboardEvent({
          name: 'SLB: UI Interaction',
          type: checked
            ? 'Filter: Enabled Loads Along Route'
            : 'Filter: Disabled Loads Along Route',
        });
      }}
    />
  );
}
